import { Editor } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { Heading } from './Heading';
import { History } from './History';
import { Links } from './Links';
import { List } from './List';
import { Media } from './Media';
import { Other } from './Other';
import { Paragraph } from './Paragraph';

import classNames from 'classnames';
import classes from './BlockTools.module.scss';

export interface BlockToolsProps {
  editor: Editor;
}

export const BlockTools: FunctionComponent<BlockToolsProps> = ({ editor }) => {
  return (
    <div
      className={classNames(classes['block-tools'], {
        [classes['block-tools--mobile']]: isMobileOnly,
      })}
    >
      <History editor={editor} />
      <Paragraph editor={editor} />
      <Heading editor={editor} />
      <List editor={editor} />
      {isMobileOnly && <div className={classes['block-tools__break']} />}
      <Links editor={editor} />
      <Media editor={editor} />
      <Other editor={editor} />
    </div>
  );
};
